export const getOperatorCatalog = (t) => ({
  string: [
    { value: "contains", label: t("filterComp.operators.contains") },
    { value: "equals", label: t("filterComp.operators.equals") },
    { value: "notequals", label: t("filterComp.operators.notequals") },
    { value: "startswith", label: t("filterComp.operators.startswith") },
    { value: "endswith", label: t("filterComp.operators.endswith") },
    { value: "in", label: t("filterComp.operators.in") },
    { value: "notin", label: t("filterComp.operators.notin") },
    { value: "isempty", label: t("filterComp.operators.isempty") },
    { value: "isnotempty", label: t("filterComp.operators.isnotempty") },
  ],
  enum: [
    { value: "equals", label: t("filterComp.operators.equals") },
    { value: "notequals", label: t("filterComp.operators.notequals") },
    { value: "in", label: t("filterComp.operators.in") },
    { value: "notin", label: t("filterComp.operators.notin") },
  ],
  boolean: [{ value: "equals", label: t("filterComp.operators.equals") }],
  numeric: [
    { value: "equals", label: t("filterComp.operators.equals") },
    { value: "notequals", label: t("filterComp.operators.notequals") },
    { value: "gt", label: t("filterComp.operators.gt") },
    { value: "gte", label: t("filterComp.operators.gte") },
    { value: "lt", label: t("filterComp.operators.lt") },
    { value: "lte", label: t("filterComp.operators.lte") },
    { value: "between", label: t("filterComp.operators.between") },
  ],
  datetime: [
    { value: "equals", label: t("filterComp.operators.equals") },
    { value: "before", label: t("filterComp.operators.before") },
    { value: "after", label: t("filterComp.operators.after") },
    { value: "between", label: t("filterComp.operators.between") },
    { value: "isempty", label: t("filterComp.operators.isempty") },
    { value: "isnotempty", label: t("filterComp.operators.isnotempty") },
  ],
  date: [
    { value: "equals", label: t("filterComp.operators.equals") },
    { value: "before", label: t("filterComp.operators.before") },
    { value: "after", label: t("filterComp.operators.after") },
    { value: "between", label: t("filterComp.operators.between") },
    { value: "isempty", label: t("filterComp.operators.isempty") },
    { value: "isnotempty", label: t("filterComp.operators.isnotempty") },
  ],
});

export const createEmptyCondition = () => ({
  id: `cond_${Date.now()}_${Math.random().toString(16).slice(2)}`,
  field: "",
  operator: "",
  value: "",
  values: [],
});

export const cloneGroup = (group) => ({
  ...group,
  conditions: group.conditions.map((condition) =>
    Array.isArray(condition.conditions) ? cloneGroup(condition) : { ...condition }
  ),
});
